import Blockly from 'blockly/browser'
import { defineBlock, getStatements } from '../Util'
import _ from 'lodash'

defineBlock(
  'javascript_variable_access',
  {
    message0: '%1',
    args0: [
      {
        type: 'field_input',
        name: 'variableName',
        text: ''
      }
    ],
    output: null,
    tooltip: 'Get value of variable',
    colour: Blockly.Msg.VARIABLES_HUE
  },
  function(block) {
    let variableName = block.getFieldValue('variableName')
    var code = variableName || 'null'
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'javascript_variable_declaration',
  {
    message0: 'declare %1',
    args0: [
      {
        type: 'input_statement',
        name: 'declarations'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'declare variables in this scope by adding assignments',
    colour: Blockly.Msg.VARIABLES_HUE
  },
  function(block) {
    const statementsDeclarations = getStatements(block.getInputTargetBlock('declarations'))
    const first = _.head(statementsDeclarations)
    if (!first) return ''
    const firstCode = `var ${first}`
    const rest = _.tail(statementsDeclarations)
    const restCode =
      rest.length > 0
        ? Blockly.JavaScript.prefixLines(rest.join(`,\n`), Blockly.JavaScript.INDENT)
        : ''
    return firstCode + (restCode ? `,\n${restCode}` : '') + ';\n'
  }
)

defineBlock(
  'javascript_variable_assign',
  {
    message0: 'set %1 to be %2',
    args0: [
      {
        type: 'field_input',
        name: 'variableName',
        text: ''
      },
      {
        type: 'input_value',
        name: 'value'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Assign a new value to an existing variable',
    colour: Blockly.Msg.VARIABLES_HUE
  },
  function(block) {
    var variableName = block.getFieldValue('variableName') || 'unnamed'
    var value =
      Blockly.JavaScript.valueToCode(block, 'value', Blockly.JavaScript.ORDER_ASSIGNMENT) || 'null'
    var code = `${variableName} = ${value};\n`
    return code
  }
)
